const linebreaksToTags = text => text.replace(/\n/ig, '<br/>');

const tagsToLinebreaks = html => html.replace(/<br\/>/ig, '\n');

export {
  linebreaksToTags,
  tagsToLinebreaks,
};



// WEBPACK FOOTER //
// ./client/src/libs/html.js